(function ($) {

   var last_scroll,
      featured,
      toggleSlider = true,
      $window      = $(window),
      $document    = $(document),
      $body        = $('body'),
      $html        = $('html'),
      scrollTop    = $document.scrollTop();

  new WOW().init({ animateClass: 'animated'});

  $('.post-gallery').magnificPopup({
    type:'image',
    delegate: 'a',
    gallery: {
      enabled: true
    },
  });   

  $document.ready(function() {


    if( $('.search-form').length ) {
      
        var gets = url('?');
        if ( gets !== undefined ) {
          $('#keyword').prop( 'value' , gets.keyword);
          $('#type').prop( 'value' , gets.type);       
          $('#min_price').prop( 'value' , gets.min_price);
          $('#max_price').prop( 'value' , gets.max_price);
          $('#length').prop( 'value' , gets.length);
          $('#order').prop( 'value' , gets.order);
        }

        $.ajax({
          type     : 'post',
          url      : vars.ajaxurl,
          data     : { action: "get_boat_makes"},
          success  : function(res) { 
              if(res) {   

                html = get_js_template({
                  source : $("#makes-template"),
                  context : { makes: res }
                }); 

                $('#make').append(html).removeProp('disabled');
                if ( gets !== undefined && gets.make ) {
                  $('#make').prop( 'value' , gets.make);
                }

              } 

          }
        });
    }
    
    if( $('#fullpage').length && $body.hasClass('fullpage_on') ) {
      runFullPage();

      $window.on('scroll', function(){
        var scroll = $window.scrollTop();
        if( scroll === 0 && !toggleSlider && last_scroll > 0) {
          $body.addClass('fullpage_on');
          runFullPage();
          $.fn.fullpage.silentMoveTo(2);
          $.fn.fullpage.moveTo(1);
          toggleSlider = true;
          $body.removeClass('scrollable');
          new WOW().init({ animateClass: 'animated'}); 
        } 
      });

    }
    else {

      $window.on('scroll', function(){
          var scroll = $window.scrollTop();
          if ( scroll > 0 ) {
            $body.addClass('scrollable');
          }
          else {
            $body.removeClass('scrollable');
          }

      });
      

    }


    $('#newsletter-form').on('submit', function(e) {

      e.preventDefault();
      var subscriber = {};

      subscriber.name = $('#newsletter-name').val();  
      subscriber.mail = $('#newsletter-email').val(); 

      $.ajax({
          dataType : 'json',
          type     : 'post',
          url      : vars.ajaxurl,
          data     : { action: "add_subscriber", subscriber : subscriber },
          success  : function(res) { 

              var html,
                  alertclass,
                  message;

              if( res === 'OK'){
                  alertclass = 'alert-success';
                  message = 'Thank you for subscribing to our newsletter.';
              } 
              else {
                  alertclass = 'alert-danger';
                  message = "Something went wrong and we can't subscribe you right now. Please try again later";
              }     

              html = get_js_template({
                  source : $("#alert-template"),
                  context : { class: alertclass, message: message }
              });

              $('#newsletter form').after(html);

          }
      });

    }); 

    function get_js_template( data ){
        var element   = data.source.html();
        var template = Handlebars.compile(element);
        return template(data.context);
    }

    $('.toggle-menu').on('click', function(){
      $('#main-nav').slideToggle();
      $(this).toggleClass('is-active');
      $body.toggleClass('mobile-menu');
    });


    if ($('#featured-slider').length > 0) {

       
        $window.load(function() {
          $('#featured-slider').flexslider({
            controlNav: false,
            prevText: "",
            nextText: "",
            animation: "slide",
            animationLoop: false,
            itemWidth: 500,
            itemMargin: 0,
            minItems: getGridSize(),
            maxItems: getGridSize(),
            start: function(slider){
              featured = slider;
            }
          });
        });

        $window.resize(function() {
          var gridSize = getGridSize();
       
          featured.vars.minItems = gridSize;
          featured.vars.maxItems = gridSize;
        });
        
    } 

    $('#testimonials-slider').flexslider({
      controlNav: true,
      directionNav: false,
      prevText: "",
      nextText: "",
      animation: "slide",
      smoothHeight: true,
      slideshow: false, 
    });


  });


  // Functions


  function getGridSize() {
    return ( window.innerWidth < 800 ) ? 1 : 2;
  }


  function runFullPage(){
    $('#fullpage').fullpage({
      scrollBar : false,
      onLeave : function(index, nextIndex, direction) {
        if(index === 1) {
          $body.addClass('scrollable');
        }
      },
      afterLoad: function(anchorLink, index){
        if (index === 2 && toggleSlider) {
          toggleSlider = false;
          $.fn.fullpage.destroy('all');
          $('#fullpage').prop('style','');
          $body.removeClass('fullpage_on');
          window.scrollTo(0, 1);  
          last_scroll = $window.scrollTop();      
        }
      },
    });
  }

  $('.gmap').each(function(){

      render_map( $(this) );

  });  

  var map, marker;

  function render_map( $el ) {

    var $markers = $el.find('.marker');
          $el.addClass('activated');
    
    var map_settings_gray = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#143d8d"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#666666"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#143d8d"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#143d8d"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#143d8d"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#143d8d"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d9eef6"}]}];
    
    var args = {
      zoom    : 14,
      center    : new google.maps.LatLng(0, 0),
      scrollwheel: false,
      styles: map_settings_gray,
      mapTypeId : google.maps.MapTypeId.ROADMAP
    };
           
    map = new google.maps.Map( $el[0], args);

    map.markers = [];

    $markers.each(function(){

        add_marker( $(this), map );

    });

    center_map( map );

  }

  function add_marker( $marker, map ) {

    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
    var image = vars.templateurl + '/img/marker.png';
    marker = new google.maps.Marker({
      position  : latlng,
      map : map,
                  icon: image
    });

    map.markers.push( marker );

    if( $marker.html() )
    {
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });

      google.maps.event.addListener(marker, 'click', function() {

        infowindow.open( map, marker );

      });
    }

  }

  function center_map( map ) {

    var bounds = new google.maps.LatLngBounds();

    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );

    });

    if( map.markers.length == 1 )
    {
        map.setCenter( bounds.getCenter() );
        map.setZoom( 13 );
    }
    else
    {
      map.fitBounds( bounds );
    }

  }  

}(jQuery));
